import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IExam, IExamQuestion } from '@/Module/Exam/Model/DataModel';
import { ExamCookieService, ExamService } from '@/Module/Exam/Service';

export const getExamQuestionListAction = createAsyncThunk<IExamQuestion[], IExam['id']>(
  'exam/getExamQuestionList',
  async (id, { signal }) => {
    const examAccessToken = ExamCookieService.getAccessToken();
    return ExamService.getExamQuestionList(id, examAccessToken, signal).then(({ data }) => data);
  },
);
